import { CheckCircle } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";

export default function PostCheckout(props: any) {
  const { fullWidth } = props;
  const location = useLocation();
  const email = location.state?.email;

  return (
    <Box
      sx={{
        p: 2,
        display: "",
        justifyContent: "center",
        alignItems: "center",
        minHeight: fullWidth ? "100%" : "calc(100vh - 80px)",
        flexDirection: "column",
        mt: '150px',
        textAlign: 'center'
      }}
    >
      <Box>
        <CheckCircle sx={{ fontSize: 60, color: "green" }} />
      </Box>

      <Typography fontSize="20px" fontWeight="600" sx={{ my: 2 }}>
        Purchase successful! Please check your email at <strong>{email}</strong> and complete the payment within 10 minutes.
      </Typography>
      <Link to="/">
        <Button variant="contained">Buy Again</Button>
      </Link>
    </Box>
  );
}
